module.exports = __webpack_public_path__ + "img/charge-bus-animation.5fd9d735.svg";